import AabDatepicker from './AabDatepicker';
import DatepickerCell from './Datepicker-cell';

customElements.define('aab-datepicker', AabDatepicker);
customElements.define('datepicker-cell', DatepickerCell);
